import React from 'react';

import  SeniorScience2025  from 'views/SeniorScience2025';

const BlogNewsroomPage = () => {

return <SeniorScience2025/>
};

export default BlogNewsroomPage;